import { Routes, Route } from "react-router-dom";

import Header from "./components/Header";
import Footer from "./components/Footer";
import BlogDetail from "./pages/BlogDetail";

import Home from "./pages/Home";
import About from "./pages/About";
import Servicepage from "./pages/Servicepage"; 
import Blog from "./pages/Blog";
import Contact from "./pages/Contact";


import './assets/css/main.css';
import './assets/css/dark-mode-style.css';
import './assets/css/bootstrap.min.css';
import './assets/css/animated.css';
import './assets/css/owl.css';

function App() {
  return (
    <>
      <Header />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Servicepage />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/contact" element={<Contact />} />
		<Route path="/blog/:slug" element={<BlogDetail />} />
      </Routes>

      <Footer />
    </>
  );
}

export default App;